"use client";

import { useEffect, useState } from "react";

/**
 * Fix for `Hydration failure in SSR when initially rendered` error.
 * Remove this function when `https://github.com/radix-ui/primitives/issues/1386` is fixed
 */
export function useRadixUIPortalFix(props: { defaultOpen?: boolean; open?: boolean }) {
	const [isOpen, setIsOpen] = useState<boolean>(false);

	useEffect(() => {
		setIsOpen(props.defaultOpen ?? props.open ?? false);
	}, [props.defaultOpen, props.open]);

	return isOpen;
}
